import React from "react";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

const CustomerForm = () => {
  const [customer, setCustomer] = useState();
  const navigate = useNavigate();

  const onCheckBox = (e) => {
    setCustomer({ ...customer, [e.target.name]: e.target.checked });
  };

  const onCloseClick = (e) => {
    navigate(`/customerlist`);
  };
  return (
    <div className="flex flex-col relative text-white px-14 py-7 bg-neutral-900 h-full">
      <div className="flex text-xs font-medium gap-3 items-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className="w-4 h-4"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M19.5 12h-15m0 0l6.75 6.75M4.5 12l6.75-6.75"
          />
        </svg>
        <label>Add New Customer</label>
        <div className="flex h-10 w-10  bg-neutral-800 justify-center items-center rounded-full">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="w-4 h-4"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M19 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zM4 19.235v-.11a6.375 6.375 0 0112.75 0v.109A12.318 12.318 0 0110.374 21c-2.331 0-4.512-.645-6.374-1.766z"
            />
          </svg>
        </div>
      </div>
      <div className="flex flex-row text-xs font-medium py-4 gap-3">
        <div className="flex flex-col">
          <label className="text-white text-sm font-medium py-2">
            Company Name
          </label>
          <input
            type="text"
            name="id"
            placeholder="Enter Company Name"
            className="block placeholder:text-white border-grey-light rounded-lg mb-4 bg-[#363945] text-white  px-5 w-80 h-9"
          />
        </div>
        <div className="flex flex-col">
          <label className="text-white text-sm font-medium py-2">
            Address
          </label>
          <input
            type="text"
            name="trucknumber"
            placeholder="Enter Address"
            className="block placeholder:text-white border-grey-light rounded-lg mb-4 bg-[#363945] text-white px-5 w-80 h-9"
          />
        </div>
      </div>
      <div className="flex flex-row text-xs font-medium py-4 gap-3" id="customerCompo">
        <div className="flex flex-col w-52">
          <label className="text-white text-sm font-medium py-2">
            Bussiness Category
          </label>
          <ComboBox
            //   data={businessData}
            dataItemKey="id"
            textField="name"
            name="businessName"
            suggest={true}
            clearButton={false}
            className=" block placeholder:text-white border-grey-light bg-[#363945] text-white px-5 h-9"
            //   onChange={handleParentChange}
            //   value={asset.parentData}
          />
        </div>
        <div className="flex flex-col w-52">
          <label className="text-white text-sm font-medium py-2">
            Country
          </label>
          <ComboBox
            //   data={businessData}
            dataItemKey="id"
            textField="country"
            name="countryName"
            suggest={true}
            clearButton={false}
            className=" block placeholder:text-white border-grey-light rounded-lg mb-4 bg-[#363945] text-white px-5 h-9"
            //   onChange={handleParentChange}
            //   value={asset.parentData}
          />
        </div>
      </div>
      <div className="flex items-center justify-center mt-14 gap-3">
        <div class="flex justify-center form-check form-check-inline mr-2">
          <label
            className="form-check-label inline-block text-white mr-3 mt-1"
            for="inlineCheckbox1"
          >
            Active
          </label>
          <input
            name="active"
            // onChange={onCheckBox}
            // checked={customer.active}
            // value={customer.active}
            className="form-check-input appearance-none h-5 w-5 border border-gray-300 rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer"
            type="checkbox"
            id="inlineCheckbox1"
          ></input>
        </div>
        <button
          type="button"
          name="create"
          //   onClick={onCloseClick}
          className=" bg-white text-black text-sm rounded-4xl w-48 h-10 px-3"
        >
          Close
        </button>
        <button
          type="submit"
          name="create"
          className="bg-violet-600 text-sm rounded-4xl w-48 h-10"
          //   onClick={onSubmit}
        >
          Create
        </button>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <ToastContainer />
    </div>
  );
};

export default CustomerForm;
